import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SocialIcons } from "./SocialIcons";

const COLS = [
  ["Customer Service", [["Contact Us", "/contact"], ["FAQ", "/faq"], ["Track Your Order", "/track-order"], ["My Account", "/account"], ["About Us", "/about"]]],
  ["Policies", [["Shipping Policy", "/policies/shipping-policy"], ["Returns & Refunds", "/policies/return-policy"], ["Privacy Policy", "/policies/privacy-policy"], ["Terms of Service", "/policies/terms-of-service"]]],
  ["Destinations", [["Orlando", "/destinations/orlando"], ["Miami", "/destinations/miami"], ["Las Vegas", "/destinations/las-vegas"], ["Hawaii", "/destinations/hawaii"], ["Cancún", "/destinations/cancun"], ["All Destinations", "/destinations"]]],
  ["Shop", [["Shop All", "/shop"], ["Funny Vacation Shirts", "/collections/funny-vacation-shirts"], ["Vacation Hats", "/collections/vacation-hats"], ["Cruise Apparel", "/collections/cruise-vacation-apparel"], ["Best Sellers", "/collections/best-sellers"]]],
];

export const Footer = () => (
  <footer className="bg-navy text-white relative overflow-hidden" data-testid="site-footer">
    <div className="h-1.5 sunset-gradient" />
    <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 lg:grid-cols-[1.3fr_repeat(4,1fr)]">
      <div>
        <Logo alt="Vacation Apparel logo" className="h-28 w-auto" loading="lazy" />
        <p className="font-brush text-3xl text-sun mt-4">Wear Your Vacation Vibes!</p>
        <p className="text-white/70 mt-2 text-sm">VacationApparel.com · @VacationApparelUSA</p>
        <SocialIcons className="mt-6" />
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <h3 className="font-bold text-sun tracking-wide uppercase text-sm mb-4">{title}</h3>
          <ul className="space-y-2.5">
            {links.map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-white/75 hover:text-white transition-colors text-[15px]" data-testid={`footer-link-${to.split("/").pop() || "home"}`}>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row gap-2 justify-between text-xs text-white/50">
        <p>© {new Date().getFullYear()} Vacation Apparel. All original designs. Printed on demand.</p>
        <p>Secure payments by Stripe</p>
      </div>
    </div>
  </footer>
);
